import React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import AppProvider from 'components/AppProvider';
import { TemplateUsageInstructions } from 'components/models/FormTemplate';
import AudienceMetadata from '../../../../models/AudienceMetadata';
import FormProps, { FormConfigProps } from '../../../../models/FormProps';
import EditTopBar, { TabIndex } from '../EditTopBar';
import ContentContainer from './ContentContainer';

interface Props {
  username: string;
  logOutUrl: string;
  tabURLs: Array<string>;
  form: FormProps & FormConfigProps;
  template: TemplateUsageInstructions;
  version: number;
  formPublishErrors: Array<string>;
  metadata: AudienceMetadata;
  metadataValuesWithHeaderUrl: string;
  hasAdditionalMetadata: boolean;
  canHaveAdditionalMetadata: boolean;
  updateUrl: string;
  updateScheduleUrl: string;
  updateFormImageUrl: string;
  previewUrl: string;
  formUrl: string;
  formsUrl: string;
  logUrl: string;
  createAnnouncementOnPgUrl: string;
  viewOnly: boolean;
  isShareableToPG: boolean;
  userID: string;
  wogaaPublishFormTrackingId: string;
  isParentForm: boolean;
  parentFormFaqUrl: string;
  editQuestionIframeSource: string;
  formsURL: string;
  v2UserGuideUrl: string;
  userFormVersionPreference: 'v1' | 'v2';
  updateUserFormVersionPreferenceUrl: string;
  enforceV2Editor?: boolean;
}

export default function Page(props: Props) {
  const { tabURLs } = props;

  return (
    <AppProvider>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <EditTopBar {...props} tab={TabIndex.Questions} setTab={tab => { location.href = tabURLs[tab]; }} />
        <ContentContainer {...props} />
      </LocalizationProvider>
    </AppProvider>
  );
}
